import React from 'react'
import successImg from "../Assets/images/success-img.svg"
import MainLogo from "../Assets/images/short-logo-white.svg"
import { useNavigate } from 'react-router-dom'
import { LanguageConstants } from '../constants/LanguageConstants'


function SuccessModal(props:any) {
  const navigate  = useNavigate()

  const handleNavigateHome =()=>{
    navigate('/')
  }
  return (
    <>
     <div className="modal fade com-modal short-modal success-modal text-center show" id="successModal" aria-labelledby="successModalLabel" aria-hidden="true" style={{ display: "block" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body py-0">
                        <img src={MainLogo} alt="Logo" className="background-logo"/> 

                            <img className="success-img" src={successImg} alt="" />
                           <div className="success-heading">{LanguageConstants?.Successful}</div>
                           <div className="px-5 mb-4">
                                <p>{LanguageConstants?.ORDER_LINE_ONE} </p>
                                <p>{LanguageConstants?.ORDER_LINE_SEC}</p>
                           </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="round-btn m-0 w-100" onClick={()=>handleNavigateHome()} >{LanguageConstants?.GO_TO_HOME}</button>
                        </div>
                    </div>
      </div>
      </div>
    </>
  )
}

export default SuccessModal